import { computed, defineComponent } from "vue";
import { showLanguagesList } from "@/utils/helpers/lang";
/**
 * Component with language options
 * Select by lang id
 *
 * @component
 * @example
 * <select-languages/>
 */

export default defineComponent({
  name: "SelectLanguages",
  setup: function setup() {
    var languages = computed(function () {
      return showLanguagesList();
    });
    return {
      languages: languages
    };
  }
});